import React from 'react';
import PropTypes from 'prop-types';
import StripeCheckout from 'react-stripe-checkout';

import { getAsset } from '../../../../../../util/assets';
import { formatPriceForDisplay } from '../../../../../../util/format-money';
import getConfig from '../../../../../../util/config';
import { CURRENCY } from '../../../../../../constants/currency';
import PriceBreakdownList from '../../../../../checkout/components/PriceBreakdownList';
import DismissButton from '../../../../../../components/global/DismissButton';
import Button from '../../../../../../components/global/Button';
import PromoCodeInput from '../../../../../../components/global/PromoCodeInput/PromoCodeInput';
import { ACCOUNT_REFERRAL_TYPE } from '../../../../../../constants/account-referrals';
import useVirtualPageView from '../../../../../../apps/pro/services/analytics/useVirtualPageView';

const propTypes = {
  pricing: PropTypes.shape({
    total_price: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.oneOf(Object.values(CURRENCY)),
    }),
    total_shipping_cost: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.oneOf(Object.values(CURRENCY)),
    }),
    total_tax: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.oneOf(Object.values(CURRENCY)),
    }),
  }),
  onClose: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onCheckout: PropTypes.func.isRequired,
  onPromoCodeSubmit: PropTypes.func.isRequired,
  loadingPricing: PropTypes.bool,
  defaultPromoCode: PropTypes.string,
};

const AccountCardCheckoutPayment = ({
  loadingPricing,
  pricing,
  onClose,
  submitting,
  onCheckout,
  onPromoCodeSubmit,
  defaultPromoCode,
}) => {
  useVirtualPageView({
    title: 'Create a card - Payment',
    path: '/payment',
  });

  const { stripe } = getConfig();
  const price = pricing?.total_price?.value;

  return (
    <div className="modal-contained-wrap">
      <div className="modal-contained-header">
        <DismissButton onClick={onClose} />

        <span className="modal-contained-title">Checkout</span>
      </div>

      <div className="modal-contained-content">
        <div className="p-2">
          <h4 className="mb-1 text-extra-bold text-faded">Total</h4>
          <PriceBreakdownList pricing={pricing} className="mb-3" />

          <h4 className="mb-1 text-extra-bold text-faded">Promo code</h4>
          <PromoCodeInput
            labelSrOnly
            defaultPromoCode={defaultPromoCode}
            onPromoCodeChange={onPromoCodeSubmit}
            accountReferralTypes={[
              ACCOUNT_REFERRAL_TYPE.WALDOGRAM_PROMO,
              ACCOUNT_REFERRAL_TYPE.TIER_1_WALDOGRAM_PROMO,
              ACCOUNT_REFERRAL_TYPE.ONE_FREE_WALDOGRAM,
            ]}
          />
        </div>
      </div>

      <div className="modal-contained-footer">
        <div className="p-2">
          <StripeCheckout
            name="Waldo Photos"
            description="Checkout"
            image={getAsset('/waldo-stripe-logo.png')}
            token={onCheckout}
            stripeKey={stripe.key}
            panelLabel={`Pay $${formatPriceForDisplay(price, true)}`}
            currency="USD"
            ComponentClass="div"
            zipCode
          >
            <Button
              disabled={submitting || loadingPricing}
              btnBlock
              btnSize="lg"
              className="btn-round"
              onClick={event => {
                if (!pricing.requires_payment) {
                  event.preventDefault();
                  event.stopPropagation();

                  onCheckout();
                }
              }}
            >
              {submitting ? 'Loading...' : 'Send card'}
            </Button>
          </StripeCheckout>
        </div>
      </div>
    </div>
  );
};

AccountCardCheckoutPayment.propTypes = propTypes;

export default AccountCardCheckoutPayment;
